import { api } from './api';

export interface CountryTaxonomy {
  code: string;
  name: string;
  taxonomy: string;
}

interface CountryTaxonomyResponse {
  success: boolean;
  data: CountryTaxonomy;
}

interface CountryTaxonomyUpdateResponse {
  success: boolean;
  message: string;
  data: CountryTaxonomy;
}

export const countryService = {
  getTaxonomy: async (): Promise<{ success: boolean; data?: CountryTaxonomy; error?: string }> => {
    try {
      const response = await api.get<CountryTaxonomyResponse>('/country/taxonomy');
      return { success: true, data: response.data.data };
    } catch (error) {
      console.error('Error al obtener taxonomía del país:', error);
      return { success: false, error: 'Error al obtener taxonomía del país' };
    }
  },

  updateTaxonomy: async (taxonomy: string): Promise<{ success: boolean; data?: CountryTaxonomy; message?: string }> => {
    try {
      const response = await api.patch<CountryTaxonomyUpdateResponse>('/country/taxonomy', { taxonomy });
      return { success: true, data: response.data.data, message: response.data.message };
    } catch (error) {
      console.error('Error al actualizar taxonomía del país:', error);
      return { success: false, message: 'Error al actualizar taxonomía del país' };
    }
  },
};
